  class IngredientGallery extends HTMLElement {
    connectedCallback() {
      this.thumbnails = this.querySelectorAll('[ref="thumbnail"]');
      this.mainImages = this.querySelectorAll('[ref="mainImage"]');
      this.descriptions = this.querySelectorAll('[ref="description"]');

      this.thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = thumb.getAttribute('data-index');

          // Remove all actives
          this.thumbnails.forEach((t) => t?.querySelector('.ingredients-thumbnail__image')?.classList.remove('active'));
          this.mainImages.forEach((img) => img?.classList.add('hidden'));
          this.descriptions.forEach((desc) => desc?.classList.add('hidden'));

          // Activate selected
          thumb?.querySelector('.ingredients-thumbnail__image')?.classList.add('active');
          this.querySelector(`.main-image__wrapper[data-index="${index}"]`)?.classList.remove('hidden');
          this.querySelector(`.ingredients-thumbnail__text-content[data-index="${index}"]`)?.classList.remove('hidden');    
        });
      });
    }
  }

  customElements.define('ingredient-gallery', IngredientGallery);